'use client';

import Link from 'next/link';
import { RiFileSearchLine } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/authStore';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const token = useAuthStore((s) => s.token);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-background">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto flex size-20 items-center justify-center rounded-full bg-primary/10">
          <RiFileSearchLine className="size-10 text-primary" />
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">{t('errorPages.notFound.title')}</h1>
          <p className="text-sm text-muted-foreground">
            {t('errorPages.notFound.description')}
          </p>
        </div>

        <Button asChild size="lg" className="w-full sm:w-auto">
          <Link href={token ? '/dashboard' : '/signin'}>
            {token ? t('errorPages.notFound.backToDashboard') : t('errorPages.notFound.backToSignin')}
          </Link>
        </Button>
      </div>
    </main>
  );
}
